// The platform's transaction-model loader, shared by every host adapter that
// has to hand a model to the shared screen stack (the approvals inbox's review
// panel, the process trail's record pane).
//
// `loadTransactionObject` returns `{ content }`, where content is either a
// TransactionRoot (`{ transaction }`) or a bare TransactionModel — the same
// unwrapping LivePreviewPage does.

import { loadTransactionObject } from '@/api/designers'
import type { TransactionModel, TransactionRoot } from '@twasta/page-runtime/txn/types'

export async function loadModel(project: string, objName: string): Promise<TransactionModel> {
  const data = await loadTransactionObject(project, objName) as { content?: unknown }
  let loaded: TransactionModel | null = null
  if (data?.content) {
    const root = data.content as TransactionRoot
    loaded = (root.transaction ? root.transaction : (data.content as TransactionModel)) ?? null
  }
  if (!loaded) {
    throw new Error(`No transaction model found for "${objName}"`)
  }
  return loaded
}
